module.exports = __webpack_public_path__ + "img/caveman.bf0d025f.png";